"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("b-modal", {
    attrs: {
      active: _vm.isModalActive,
      width: 720,
      scroll: "keep"
    },
    on: {
      close: function close($event) {
        return _vm.$emit("onClose");
      }
    }
  }, [_c("form", {
    on: {
      submit: function submit($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments);
      }
    }
  }, [_c("header", {
    staticClass: "modal-card-head"
  }, [_c("p", {
    staticClass: "modal-card-title"
  }, [_vm._v("\n        Nova escala de horário\n      ")]), _vm._v(" "), _c("button", {
    staticClass: "delete",
    attrs: {
      type: "button"
    },
    on: {
      click: function click($event) {
        return _vm.$emit("onClose");
      }
    }
  })]), _vm._v(" "), _c("section", {
    staticClass: "modal-card-body modal-body"
  }, [_c("b-field", {
    attrs: {
      label: "Título"
    }
  }, [_c("b-input", {
    attrs: {
      required: ""
    },
    model: {
      value: _vm.form.title,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "title", $$v);
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "grid-2 gap-16"
  }, [_c("b-field", {
    attrs: {
      label: "Início do turno"
    }
  }, [_c("b-timepicker", {
    attrs: {
      placeholder: "Selecione a hora",
      "hour-format": "24",
      required: ""
    },
    model: {
      value: _vm.form.startShift,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "startShift", $$v);
      },
      expression: "form.startShift"
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Término do turno"
    }
  }, [_c("b-timepicker", {
    attrs: {
      placeholder: "Selecione a hora",
      "hour-format": "24",
      required: ""
    },
    model: {
      value: _vm.form.endShift,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "endShift", $$v);
      },
      expression: "form.endShift"
    }
  })], 1)], 1), _vm._v(" "), _c("b-field", {
    staticClass: "mt-16",
    attrs: {
      label: "Dias da semana"
    }
  }, [_c("ul", {
    staticClass: "weekday-list"
  }, [_c("li", [_c("b-checkbox", {
    attrs: {
      "native-value": 0
    },
    model: {
      value: _vm.form.weekdays,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "weekdays", $$v);
      },
      expression: "form.weekdays"
    }
  }, [_vm._v("\n              Dom\n            ")])], 1), _vm._v(" "), _c("li", [_c("b-checkbox", {
    attrs: {
      "native-value": 1
    },
    model: {
      value: _vm.form.weekdays,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "weekdays", $$v);
      },
      expression: "form.weekdays"
    }
  }, [_vm._v("\n              Seg\n            ")])], 1), _vm._v(" "), _c("li", [_c("b-checkbox", {
    attrs: {
      "native-value": 2
    },
    model: {
      value: _vm.form.weekdays,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "weekdays", $$v);
      },
      expression: "form.weekdays"
    }
  }, [_vm._v("\n              Ter\n            ")])], 1), _vm._v(" "), _c("li", [_c("b-checkbox", {
    attrs: {
      "native-value": 3
    },
    model: {
      value: _vm.form.weekdays,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "weekdays", $$v);
      },
      expression: "form.weekdays"
    }
  }, [_vm._v("\n              Qua\n            ")])], 1), _vm._v(" "), _c("li", [_c("b-checkbox", {
    attrs: {
      "native-value": 4
    },
    model: {
      value: _vm.form.weekdays,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "weekdays", $$v);
      },
      expression: "form.weekdays"
    }
  }, [_vm._v("\n              Qui\n            ")])], 1), _vm._v(" "), _c("li", [_c("b-checkbox", {
    attrs: {
      "native-value": 5
    },
    model: {
      value: _vm.form.weekdays,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "weekdays", $$v);
      },
      expression: "form.weekdays"
    }
  }, [_vm._v("\n              Sex\n            ")])], 1), _vm._v(" "), _c("li", [_c("b-checkbox", {
    attrs: {
      "native-value": 6
    },
    model: {
      value: _vm.form.weekdays,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "weekdays", $$v);
      },
      expression: "form.weekdays"
    }
  }, [_vm._v("\n              Sáb\n            ")])], 1)])]), _vm._v(" "), _c("div", {
    staticClass: "add-break-footer space-between mt-16"
  }, [_c("p", {
    staticClass: "subtitle-modal"
  }, [_vm._v("\n          Intervalos\n        ")]), _vm._v(" "), _c("b-button", {
    staticClass: "btn",
    attrs: {
      type: "is-primary",
      size: "is-small"
    },
    on: {
      click: _vm.addBreak
    }
  }, [_vm._v("\n          Adicionar intervalo\n        ")])], 1), _vm._v(" "), _c("b-field", {
    staticClass: "mt-8"
  }, [_c("ul", {
    staticClass: "break-list"
  }, _vm._l(_vm.form.breaks, function (brk, i) {
    return _c("li", {
      key: i,
      staticClass: "break-item"
    }, [_c("div", {
      staticClass: "box break-box"
    }, [_c("b-field", {
      attrs: {
        label: "Título do intervalo"
      }
    }, [_c("b-input", {
      attrs: {
        placeholder: "Ex.: Almoço",
        required: ""
      },
      model: {
        value: brk.title,
        callback: function callback($$v) {
          _vm.$set(brk, "title", $$v);
        },
        expression: "brk.title"
      }
    })], 1), _vm._v(" "), _c("div", {
      staticClass: "grid-2 gap-12 mt-8"
    }, [_c("b-field", {
      attrs: {
        label: "Início"
      }
    }, [_c("b-timepicker", {
      attrs: {
        placeholder: "Selecione a hora",
        "hour-format": "24",
        required: ""
      },
      model: {
        value: brk.start,
        callback: function callback($$v) {
          _vm.$set(brk, "start", $$v);
        },
        expression: "brk.start"
      }
    })], 1), _vm._v(" "), _c("b-field", {
      attrs: {
        label: "Fim"
      }
    }, [_c("b-timepicker", {
      attrs: {
        placeholder: "Selecione a hora",
        "hour-format": "24",
        required: ""
      },
      model: {
        value: brk.end,
        callback: function callback($$v) {
          _vm.$set(brk, "end", $$v);
        },
        expression: "brk.end"
      }
    })], 1)], 1), _vm._v(" "), _c("div", {
      staticClass: "break-actions"
    }, [_vm.form.breaks.length > 1 ? _c("b-button", {
      attrs: {
        type: "is-danger",
        size: "is-small",
        outlined: ""
      },
      on: {
        click: function click($event) {
          return _vm.removeBreak(i);
        }
      }
    }, [_vm._v("\n                  Remover intervalo\n                ")]) : _vm._e()], 1)], 1)]);
  }), 0)])], 1), _vm._v(" "), _c("footer", {
    staticClass: "modal-card-foot"
  }, [_c("b-button", {
    staticClass: "btn",
    attrs: {
      type: "is-primary",
      "native-type": "submit",
      loading: _vm.isLoading
    }
  }, [_vm._v("\n        Salvar\n      ")]), _vm._v(" "), _c("b-button", {
    on: {
      click: function click($event) {
        return _vm.$emit("onClose");
      }
    }
  }, [_vm._v("\n        Cancelar\n      ")])], 1)])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;